
import React from 'react';
import { Button } from '@/components/ui/button';
import { Copy, Edit, Star, Trash2, Mail } from 'lucide-react';
import { CommunicationTemplate } from '@/services/communication/templates';

interface TemplateActionsProps {
  template: CommunicationTemplate;
  onEdit: (template: CommunicationTemplate) => void;
  onCopy: (template: CommunicationTemplate) => void;
  onDelete: (id: string) => void;
  onSendEmail?: (template: CommunicationTemplate) => void;
}

const TemplateActions: React.FC<TemplateActionsProps> = ({
  template,
  onEdit,
  onCopy,
  onDelete,
  onSendEmail,
}) => {
  const isEmailTemplate = template.type === 'email';
  
  return (
    <div className="absolute top-2 right-2 flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
      {template.isDefault && (
        <Button size="sm" variant="secondary" className="h-8 w-8 p-0 bg-background/95 backdrop-blur hover:bg-secondary">
          <Star className="h-4 w-4 text-yellow-500" />
        </Button>
      )}
      {isEmailTemplate && onSendEmail && (
        <Button 
          size="sm" 
          variant="secondary" 
          className="h-8 w-8 p-0 bg-background/95 backdrop-blur hover:bg-secondary"
          onClick={(e) => {
            e.stopPropagation();
            onSendEmail(template);
          }}
          title="Send Email"
        >
          <Mail className="h-4 w-4 text-primary" />
        </Button>
      )}
      <Button
        size="sm" 
        variant="secondary" 
        className="h-8 w-8 p-0 bg-background/95 backdrop-blur hover:bg-secondary"
        onClick={(e) => {
          e.stopPropagation();
          onCopy(template);
        }}
      >
        <Copy className="h-4 w-4" />
      </Button>
      <Button 
        size="sm" 
        variant="secondary" 
        className="h-8 w-8 p-0 bg-background/95 backdrop-blur hover:bg-secondary"
        onClick={(e) => {
          e.stopPropagation();
          onEdit(template);
        }}
      >
        <Edit className="h-4 w-4" />
      </Button>
      <Button 
        size="sm" 
        variant="secondary" 
        className="h-8 w-8 p-0 bg-background/95 backdrop-blur hover:bg-destructive hover:text-destructive-foreground"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(template.id);
        }}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default TemplateActions;
